import {configureStore} from '@reduxjs/toolkit';
import {createWrapper} from 'next-redux-wrapper';
import AppLayout from "@/lib/redux/reducers/app-layout";
import QuestionProgressbar from "@/lib/redux/reducers/question-progressbar";
import proctoringSetupConfig from "@/lib/redux/reducers/proctoring-setup";

export const makeStore = () =>
    configureStore({
        reducer: {
            appLayout: AppLayout,
            questionsProgressbar: QuestionProgressbar,
            proctoringSetupConfig: proctoringSetupConfig
        },
        devTools: process.env.NODE_ENV !== 'production',
    });

export type AppStore = ReturnType<typeof makeStore>;
export type AppState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];

export const wrapper = createWrapper<AppStore>(makeStore);
